export const getRating = (type: number) => {
  if (type >= 4.5) {
    return 'Mükemmel';
  } else if (type >= 4 && type < 4.5) {
    return 'Çok iyi';
  } else if (type >= 3 && type < 4) {
    return 'İyi';
  } else if (type < 3) {
    return 'Orta';
  }
};

export const getRatingAboveFour = (type: number) => type >= 4;
